import { Component, Input, OnChanges, SimpleChanges, ViewChild } from '@angular/core';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CommonServiceService } from 'src/app/share/services/common-service/common-service.service';
import { DayBookService } from 'src/app/share/services/day-book/day-book.service';

@Component({
  selector: 'app-day-cash-summary',
  templateUrl: './day-cash-summary.component.html',
  styleUrl: './day-cash-summary.component.scss',
  standalone: false,
})
export class DayCashSummaryComponent implements OnChanges {
  
  protected readonly faChevronRight = faChevronRight;

  @ViewChild('summaryModal') summaryModalTemplate!: any;

  @Input() selectedDate: any;
  @Input() selectedBranch: any;


  loader: boolean = false;
  errMsg: any = '';
  summaryList: any[] = [];
  highlightcards: any = {
    openingCash:0,
    closingCash:0,
    cashFromSales: 0,
    cashExpenses: 0,
  }
  

  constructor(
    private readonly dayBookService: DayBookService,
    private readonly modalService: NgbModal,
    private readonly cmnService: CommonServiceService,
  ){}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['selectedDate'] || changes['selectedBranch']) {
      this.refreshHighlights()
      this.getCashSummary();
      this.getCashSummaryList();
    }
  }

  refreshHighlights() {
    this.highlightcards = {
      openingCash: 0,
      closingCash: 0,
      cashFromSales: 0,
      cashExpenses: 0,
    }
  }


  getCashSummary() {
    let payload = this.getPayload();
    this.dayBookService.getCashSummary(payload).subscribe({
      next:(res: any) => {
        let data = res.data || {};
        Object.keys(this.highlightcards).forEach(key => {
          this.highlightcards[key] = this.cmnService.parseNumberOrZero(data[key]);
        });
      }
    })
  }


  getCashSummaryList() {
    let payload = this.getPayload();
    this.loader = true
    this.dayBookService.getCashSummaryList(payload).subscribe({
      next: (res: any) => {
        let data = res?.data || []
        this.summaryList = data.map((item: any)=> {
          return {
            ...item,
            totalSales: this.cmnService.parseNumberOrNull(item.totalSales)
          };
        })
        this.loader = false
      },
      error: (error: any) => {
        this.loader = false;
        this.errMsg = error?.error
      }
    })
  }

  getPayload() {
    let payload: any = {
      created_date: this.selectedDate
    };
    if (this.selectedBranch) payload.company = this.selectedBranch;
    return payload;
  }

  viewAllSummary() {
    this.modalService.open(this.summaryModalTemplate, { size: 'lg', centered: true, scrollable: true });
  }

}
